// @ts-nocheck

import { __ } from '../../../../i18n/l10n';
import { MatchStatuses } from '../../../../types/match';
import { GridsCheckTypes } from '../../types';

export const tutoSelection = '010100100110010110001';

export const tutoResultSelection = '010100100100010010001';

export const tutoSystemSelection = '012100120100110010001';

export const tutoMatchs = [
  {
    matchId: 1,
    status: MatchStatuses.PREMATCH,
    competitor1Name: __('Paris SG'),
    competitor2Name: __('Manchester United'),
    competitor1Id: 1,
    competitor2Id: 2,
    matchStart: 1563854400,
    score1: 1,
    score2: 2,
  },
  {
    matchId: 2,
    status: MatchStatuses.PREMATCH,
    competitor1Name: __('Shaktar Donetsk'),
    competitor2Name: __('Real Madrid'),
    competitor1Id: 3,
    competitor2Id: 4,
    matchStart: 1563854400,
    score1: 0,
    score2: 0,
  },
  {
    matchId: 3,
    status: MatchStatuses.PREMATCH,
    competitor1Name: __('Atletico Madrid'),
    competitor2Name: __('Bayern Munich'),
    competitor1Id: 5,
    competitor2Id: 6,
    matchStart: 1563854400,
    score1: 1,
    score2: 1,
  },
  {
    matchId: 4,
    status: MatchStatuses.PREMATCH,
    competitor1Name: __("Borussia M'Gladbach"),
    competitor2Name: __('Inter Milan'),
    competitor1Id: 7,
    competitor2Id: 8,
    matchStart: 1563854400,
    score1: 3,
    score2: 0,
  },
  {
    matchId: 5,
    status: MatchStatuses.PREMATCH,
    competitor1Name: __('Marseille'),
    competitor2Name: __('Olympiakos'),
    competitor1Id: 9,
    competitor2Id: 10,
    matchStart: 1563854400,
    score1: 4,
    score2: 2,
  },
  {
    matchId: 6,
    status: MatchStatuses.PREMATCH,
    competitor1Name: __('FC Porto'),
    competitor2Name: __('Manchester City'),
    competitor1Id: 11,
    competitor2Id: 12,
    matchStart: 1563854400,
    score1: 2,
    score2: 1,
  },
  {
    matchId: 7,
    status: MatchStatuses.PREMATCH,
    competitor1Name: __('Liverpool'),
    competitor2Name: __('Ajax Amsterdam'),
    competitor1Id: 13,
    competitor2Id: 14,
    matchStart: 1563854400,
    score1: 1,
    score2: 1,
  },
];

export const tutoChecks = [
  {
    key: GridsCheckTypes.HOME,
    typeCheck: GridsCheckTypes.HOME,
  },
  {
    key: GridsCheckTypes.NULL,
    typeCheck: GridsCheckTypes.NULL,
  },
  {
    key: GridsCheckTypes.EXT,
    typeCheck: GridsCheckTypes.EXT,
  },
];
